import { Components } from "appworks/components/components";
import { SpineBigWinTransition } from "appworks/transitions/spine-big-win-transition";
import { Contract } from "appworks/utils/contracts/contract";
import { TGRMatrixComponent } from "components/tgr-matrix";

export class TGRSpineBigWinTransition extends SpineBigWinTransition {

    public in(): Contract<void> {
        return this.cancelGroup.parallel([
            () => Components.get(TGRMatrixComponent).darkenReels(true, 500),
            () => super.in()
        ]);
    }

    public out(): Contract<void> {
        return this.cancelGroup.parallel([
            () => Components.get(TGRMatrixComponent).darkenReels(false, 250),
            () => super.out()
        ]);
    }
}
